import { Directive, HostListener, Input } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';

@Directive({
  selector: '[appMatVerticalStepperScroller]',
})
export class MatVerticalStepperScrollerDirective {
  @Input('appMatVerticalStepperScroller') orientation = 'horizontal';

  constructor(private stepper: MatStepper) {}

  @HostListener('animationDone')
  selectionChanged() {
    if (this.orientation === 'vertical') {
      const stepId = this.stepper._getStepLabelId(this.stepper.selectedIndex);
      const stepElement = document.getElementById(stepId);
      if (stepElement) {
        stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
      }
    }
  }
}
